export default __webpack_public_path__ + "static/media/2_3-thumbnail-chip-left.7096f48a.png";